module.exports = __webpack_public_path__ + "media/images/vp/icon.download.red-e625041c32e3628491f2d46c289f769b.svg";